<template>
  <v-container>
    <v-card color="pop_bg">
      <v-card-text>
        <v-container class="mt-2">
          <v-layout>
            <v-flex md4> Check Paid Status </v-flex>
            <v-flex>
              <v-btn color="primary" class="mb-2 mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="checkPaidStatus" :loading="btnloading">
                Check Status
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md4> Mark as paid </v-flex>
            <v-flex md4>
              <v-select :items="['OFFLINE']" dense attach solo value="OFFLINE"> </v-select>
            </v-flex>
            <v-flex class="ml-4">
              <v-btn color="error" class="mb-2 mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="markAsPaid" :loading="btnloading">
                Confirm
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-dialog v-model="showConfirmPaidDialog" max-width="800px">
        <v-card color="pop_bg">
          <v-card-title>
            <span class="text-h6 error--text">Confirm</span>
            <v-spacer></v-spacer>
            <AuditTrialLog auditType="TAX_UPDATE" />
            <v-btn color="primary" class="light--text" text @click="showConfirmPaidDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container class="mt-2"><span class="text-h6 dark--text">Are you sure want to mark this as paid</span> </v-container>
          </v-card-text>

          <v-card-actions class="justify-end mt-n8">
            <v-btn color="error" class="mb-2 mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="confirmPaid" :loading="btnConfirmPaid">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-snackbar v-model="snackbar" timeout="3000" right top :color="color">{{ text }}</v-snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  props: {
    history: {
      required: true,
    },
  },
  methods: {
    markAsPaid() {
      this.showConfirmPaidDialog = true;
    },

    confirmPaid() {
      this.btnloading = true;
      this.btnConfirmPaid = true;
      this.$apollo
        .mutate({
          mutation: require("./api/planSwitchMarkAsPaid.graphql"),
          variables: {
            input: {
              history: this.history._id,
              customerId: this.history.customer._id,
            },
          },
        })
        .then(() => {
          this.showConfirmPaidDialog = false;
          this.btnloading = false;
          this.btnConfirmPaid = false;
          this.snackbar = true;
          this.text = "Plan switch market as paid.";
          this.color = "success";
          this.$root.$emit("updateGetCustomerById");
          this.$root.$emit("updatePlanswitchList");
          this.$root.$emit("closePlanSwitchWindows");
        })
        .catch(error => {
          // Error
          this.btnloading = false;
          this.btnConfirmPaid = false;
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
    },
    checkPaidStatus() {
      this.btnloading = true;
      this.$apollo
        .watchQuery({
          query: require("./api/checkPlanSwitchOnlinePaymentStatus.graphql"),
          variables: {
            history: this.history._id,
          },
        })
        .refetch({
          history: this.history._id,
        })
        .then(data => {
          this.btnloading = false;
          if (data.data.checkPlanSwitchOnlinePaymentStatus) {
            this.snackbar = true;
            this.text = "Payment received successfuly";
            this.color = "success";
          } else {
            this.snackbar = true;
            this.text = "Payment not received";
            this.color = "error";
          }
          this.$root.$emit("updatePlanswitchList");
        })
        .catch(error => {
          this.btnloading = false;
          console.log(error);
        });
    },
  },
  data: () => ({
    loading: true,
    btnloading: false,
    showConfirmPaidDialog: false,
    show_dialog_box: false,
    btnConfirmPaid: false,
    snackbar: false,
    text: "",
    color: "",
  }),

  created() {},
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
